import AccountAvatarUploadComponent from './account-avatar-upload.component'

const AccountAvatarUploadModule = angular.module('cdbl.account-avatar-upload', [

])
  .component('cdblAccountAvatarUpload', AccountAvatarUploadComponent)
  .name

export default AccountAvatarUploadModule
